import React, { useEffect, useState } from "react";
import { Badge, Button, Empty, Popover } from "src/assets/imports/antdComponents";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { setCampaignVisibility, setReflectiveModeToSet } from "src/pages/Studies/states/studiesSlice";
import { useFeatures } from "src/config/featureManager";
import { FeatureKeysType, FeatureList } from "src/pages/Studies/models/interfaces";
import { useNavigate } from "react-router-dom";
import {
	resetIdConfigChat,
	resetReferenceItems,
	setAskKuralStudySelectDrawerVisible,
	setChatError,
	setHasSeenReflectiveModeDot,
	setIsButtonDisabled,
	setIsChatAvailableForCurrentChat,
	setIsCompDisabled,
	setIsEnterDisabled,
	setIsStandardQueryMode,
	setIsSavedQuery,
	setReferenceDrawerVisibility,
	setSelectedBranchId,
	setSelectedChatData,
	setSelectedChatId,
	updateAbortStreamingAskKural,
} from "src/pages/NewAskKural/states/askKuralSlice";
import { AskKuralVersionType, ReferenceDrawerVisibilityType } from "src/pages/NewAskKural/models/interfaces";
import { resetCountWidget, setCountWigets, updateAbortStreamingCountChat, updateAbortStreamingCountWidget } from "src/pages/NewAskKural/states/countWidgetSlice";
import {
	resetAllWidgetProps,
	resetWidgetHeading,
	resetWidgetStudyPayload,
	resetWidgetText,
	setIsWidgetExpanded,
	setOpenWidgetProps,
	setWidgetDropdownData,
	setWidgetOpen,
} from "src/pages/NewAskKural/states/widgetSlice";

interface NotificationItem {
	id: number;
	feature_name?: string;
	message: string;
	isRead: boolean;
	actionText?: string;
}

const Notification: React.FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const { featureList } = useSelector((state: any) => state.studiesSlice);
	const [notifications, setNotifications] = useState<NotificationItem[]>([]);
	const { isFeatureAvailable } = useFeatures();
	const isReflectiveModeCampaignEnabled = isFeatureAvailable(FeatureKeysType.ReflectiveModeCampaign);
	const { askKuralVersion, selectedQueriesConfig } = useSelector((state: any) => state.askKuralSlice);
	const shouldShowNotficationPopup = featureList?.some(
		(feature) => feature.feature_name === FeatureList.ReflectiveMode && feature.approved === true && feature.show_congrats === false,
	);

	useEffect(() => {
		if (featureList.length > 0) {
			const arr = featureList.map((feature: any, index: number) => ({
				id: index,
				message: `Ask Kural "Reflective Mode" is now launched. Register now to avail using this deep-analysis feature.`,
				isRead: !feature.show_notification,
				actionText: "Get Early Access",
				feature_name: feature.feature_name,
			}));
			setNotifications(arr);
		} else {
			setNotifications([]);
		}
	}, [featureList]);

	const unreadCount = notifications.filter((n) => !n.isRead).length;

	const handleOpenChange = (newOpen: boolean) => {
		setOpen(newOpen);
	};

	const notificationContent = (
		<div className="notification-popover w-[400px]">
			<div className="flex justify-start items-center px-4 py-3">
				<span className="text-base font-semibold text-[--secondary-color]">Notifications</span>
			</div>
			<div className="max-h-[400px] overflow-y-auto">
				{isReflectiveModeCampaignEnabled && notifications.length > 0 && (
					<>
						{notifications.map((notification) => (
							<div
								key={notification.id}
								className={`flex gap-3 px-4 py-3 border-b border-[--neutral-grey-opacity-10] hover:bg-[--neutral-grey-opacity-5] cursor-pointer bg-[--drawer-header-bg] `}>
								<div className="flex-1 min-w-0 ">
									<div className="text-sm">
										<span className="text-[--tertiary-color]">
											Ask Kural <span style={{ color: "#8571F4" }}>"Reflective Mode"</span> is now available for Early Access. Register now to try it.
										</span>
									</div>
									<div className="flex items-center justify-end mt-1">
										{!notification.isRead ? (
											<Button
												icon={<i className="material-symbols-outlined text-[--primary-color] text-sm">chevron_right</i>}
												iconPosition="end"
												className={`${
													!notification.isRead ? "text-[--primary-color]" : "text-[--tertiary-color]"
												} text-sm border-none bg-transparent shadow-none hover:bg-transparent hover:shadow-none p-0 h-auto flex items-center cursor-pointer gap-0`}
												onClick={(e) => {
													e.stopPropagation();
													dispatch(setCampaignVisibility(true));
													setOpen(false);
												}}>
												{notification.actionText}
											</Button>
										) : (
											<div className="text-sm text-[--tertiary-color]">You have Already Registered!</div>
										)}
									</div>
								</div>
							</div>
						))}
					</>
				)}

				{shouldShowNotficationPopup && (askKuralVersion[selectedQueriesConfig] === AskKuralVersionType.v3_2 || askKuralVersion[selectedQueriesConfig] === AskKuralVersionType.v3_3) && (
					<div className={`flex gap-3 px-4 py-3 border-b border-[--neutral-grey-opacity-10] hover:bg-[--neutral-grey-opacity-5] cursor-pointer bg-[--drawer-header-bg] `}>
						<div className="flex-1 min-w-0 ">
							<div className="text-sm">
								<span className="text-[--tertiary-color]">
									Congratulations! You now have access to Reflective Mode. You can start using it right away in Ask Kural.
								</span>
							</div>
							<div className="flex items-center justify-end mt-1">
								<Button
									icon={<i className="material-symbols-outlined text-[--primary-color] text-sm">chevron_right</i>}
									iconPosition="end"
									className={`text-[--primary-color] text-sm border-none bg-transparent shadow-none hover:bg-transparent hover:shadow-none p-0 h-auto flex items-center cursor-pointer gap-0`}
									onClick={(e) => {
										e.stopPropagation();
										dispatch(setReflectiveModeToSet(true));
										dispatch(setSelectedChatData(null));
										dispatch(setSelectedChatId(null));
										dispatch(setSelectedBranchId(null));
										dispatch(setIsChatAvailableForCurrentChat(null));
										dispatch(setIsCompDisabled(false));
										dispatch(setReferenceDrawerVisibility(ReferenceDrawerVisibilityType.hidden));
										dispatch(resetReferenceItems());
										dispatch(updateAbortStreamingAskKural(null));
										dispatch(setChatError(false));
										dispatch(setAskKuralStudySelectDrawerVisible(false));
										dispatch(resetAllWidgetProps());
										dispatch(resetIdConfigChat());
										dispatch(setWidgetOpen(false));
										dispatch(setIsWidgetExpanded(false));
										dispatch(setOpenWidgetProps({ data: {}, query_id: "" }));
										dispatch(resetWidgetStudyPayload());
										dispatch(setWidgetDropdownData({}));
										dispatch(resetWidgetHeading());
										dispatch(resetWidgetText());
										dispatch(resetCountWidget());
										dispatch(setIsSavedQuery(false));
										dispatch(setCountWigets([]));
										dispatch(updateAbortStreamingCountWidget(null));
										dispatch(updateAbortStreamingCountChat(null));
										dispatch(setIsButtonDisabled(false));
										dispatch(setIsEnterDisabled(false));
										// Mark the dot as seen
										dispatch(setHasSeenReflectiveModeDot(true));
										dispatch(setIsStandardQueryMode(true));
										navigate("/ask-kural");
										setOpen(false);
									}}>
									Try Reflective Mode
								</Button>
							</div>
						</div>
					</div>
				)}

				{/* Show Empty only when there are no notifications at all */}
				{!isReflectiveModeCampaignEnabled && !shouldShowNotficationPopup && <Empty description="No notifications" className="py-8" />}
			</div>
		</div>
	);

	return (
		<Popover content={notificationContent} placement="bottomRight" trigger="click" open={open} onOpenChange={handleOpenChange} overlayClassName="notification-popover-overlay" rootClassName="top-navbar-popover">
			<Badge dot={unreadCount > 0} offset={[-10, 10]} color="#ff4d4f">
				<Button type="text" icon={<i className="material-symbols-outlined text-[--primary-color]">{"notifications"}</i>} className="flex items-center justify-center" />
			</Badge>
		</Popover>
	);
};

export default Notification;
